import { useEffect, useState } from 'react'
import { BooksitoutServer } from '../../../config/BooksitoutServer'

interface OtherEdition {
	isbn13: string
	title: string
	coverUrl: string | null
	authors: string | null
	memo: string | null
}

const useBookIsbnOtherEditions = (isbn: string | null) => {
	const [editions, setEditions] = useState<OtherEdition[]>([])
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		if (isbn == null) {
			setIsLoading(false)
			return
		}

		BooksitoutServer.get(`/v1/book-isbn/${isbn}/other-editions`)
			.then(res => setEditions(res.data))
			.catch(() => {})
			.finally(() => setIsLoading(false))
	}, [isbn])

	return [editions, isLoading] as const
}

export default useBookIsbnOtherEditions
export type { OtherEdition }
